import { styled, keyframes } from "styled-components";

interface SpinnerProps {
  size?: "small" | "default" | "large";
  tip?: string;
}

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const SpinnerRing = styled.div<{ $size: "small" | "default" | "large" }>`
  border: ${({ $size }) => ($size === "small" ? "2px" : $size === "large" ? "4px" : "3px")} solid ${({ theme }) => theme.colors.grey100};
  border-top: ${({ $size }) => ($size === "small" ? "2px" : $size === "large" ? "4px" : "3px")} solid ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  width: ${({ $size }) => ($size === "small" ? "16px" : $size === "large" ? "48px" : "32px")};
  height: ${({ $size }) => ($size === "small" ? "16px" : $size === "large" ? "48px" : "32px")};
  animation: ${spin} 0.8s linear infinite;
`;

const Tip = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 14px;
`;

export const Spinner = ({ size = "default", tip }: SpinnerProps) => {
  return (
    <SpinnerWrapper>
      <SpinnerRing $size={size} />
      {tip && <Tip>{tip}</Tip>}
    </SpinnerWrapper>
  );
};

// Full page spinner overlay
const OverlayWrapper = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const SpinnerOverlay = ({ tip }: { tip?: string }) => {
  return (
    <OverlayWrapper>
      <Spinner size="large" tip={tip} />
    </OverlayWrapper>
  );
};
